import * as BiIcons from "react-icons/bi";
import * as BsIcons from "react-icons/bs";
import {type MouseEvent, useContext} from "react";
import TerminalContainerContext, {type TerminalTab} from "./TerminalContainerContext.ts";

interface TerminalScreenContainerTabProps {
    tab: TerminalTab
}

export default function TerminalContainerTab({tab}: TerminalScreenContainerTabProps) {
    const context = useContext(TerminalContainerContext)!;

    function onClickTab() {
        context.activeTab = tab;
        context.closeSearchDialog();
    }

    function onClickCloseTab(e: MouseEvent) {
        e.stopPropagation();
        context.closeTab(tab.tabKey!);
        context.closeSearchDialog();
    }

    function createActiveClass() {
        return tab === context.activeTab ? 'active' : '';
    }

    return (
        <li
            data-key={tab.reqKey}
            className={`terminal-tab nav-item ${createActiveClass()}`}
            style={{cursor: 'pointer'}}
        >
            <a
                className={`nav-link d-inline-flex align-items-center ${createActiveClass()}`}
                onClick={onClickTab}
            >
                {tab.title === "Terminal" || ""
                    ? (<span className="spinner"></span>)
                    : (<span className="d-none"><BiIcons.BiUnlink/></span>)}
                {tab.title}
                <button
                    type="button"
                    className="btn p-0 ms-2"
                    aria-label="Close"
                    onClick={onClickCloseTab}
                ><BsIcons.BsX/></button>
            </a>
        </li>
    );
}